var _effectorFileName = "/builds/gmini/front-ui-kit/src/Tabs/Tabs.tsx";
import { useEffect, useRef, useState } from 'react';
import { ArrowTabs } from '../icons';
import { Tab, Header, Content, Divider, TabTitle, BadgeWrapper, PreviousTabsCounter, NextTabsCounter, CounterWrapper } from './Tabs.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const Tabs = ({
  activeTabIndex,
  onChangeTab,
  tabs,
  disabled,
  headerStyles,
  contentStyles,
  invisibleHeaderScroll
}) => {
  const headerRef = useRef(null);
  const [hoverTab, setHoverTab] = useState(false);
  const [tabsPlacementCount, setTabsPlacementCount] = useState({
    previous: 0,
    next: 0
  });
  const gap = (headerStyles === null || headerStyles === void 0 ? void 0 : headerStyles.gap) || 20;
  useEffect(() => {
    if (!headerRef.current) {
      return;
    }

    handleScroll(headerRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollOnClick = (direction, el = headerRef.current) => {
    if (!el) {
      return;
    }

    const averageChildWidth = Array.of(...el.children).reduce((acc, child) => acc + child.clientWidth, 0) / el.children.length;
    const scrollChildrenCount = 3;
    const value = direction === 'forward' ? averageChildWidth * scrollChildrenCount : -averageChildWidth * scrollChildrenCount;
    el.scrollTo({
      left: el.scrollLeft + value,
      behavior: 'smooth'
    });
  };

  const handleScroll = header => {
    const windowStart = header.scrollLeft;
    const windowEnd = windowStart + header.clientWidth;
    const headerChildren = Array.of(...header.children);
    const tabsPlacementCount = headerChildren.reduce((acc, child, idx) => {
      if (idx === 0 || idx === header.children.length - 1) {
        return acc;
      }

      const childStart = acc.currentDistance;
      const childEnd = childStart + child.clientWidth;
      const currentDistance = childEnd + gap;

      if (childStart < windowStart) {
        return { ...acc,
          previous: acc.previous + 1,
          currentDistance
        };
      } else if (childEnd > windowEnd + 15) {
        return { ...acc,
          next: acc.next + 1,
          currentDistance
        };
      }

      return { ...acc,
        currentDistance
      };
    }, {
      previous: 0,
      next: 0,
      currentDistance: 0
    });
    const {
      next,
      previous
    } = tabsPlacementCount;
    setTabsPlacementCount({
      next,
      previous
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Header, {
      style: { ...headerStyles,
        gap: undefined
      },
      gap: gap,
      invisibleHeaderScroll: invisibleHeaderScroll,
      onScroll: e => handleScroll(e.currentTarget),
      ref: headerRef,
      children: [/*#__PURE__*/_jsx(PreviousTabsCounter, {
        visible: Boolean(tabsPlacementCount.previous),
        onClick: () => scrollOnClick('back'),
        children: /*#__PURE__*/_jsxs(CounterWrapper, {
          children: [/*#__PURE__*/_jsx(ArrowTabs, {
            style: {
              transform: 'rotate(180deg)'
            }
          }), tabsPlacementCount.previous]
        })
      }), tabs.map((tab, tabIndex) => /*#__PURE__*/_jsxs(Tab, {
        "data-test-id": tab.dataTestId,
        onClick: () => !disabled && !tab.disabled && onChangeTab(tabIndex),
        active: tabIndex === activeTabIndex,
        disabled: disabled || tab.disabled // eslint-disable-next-line react/no-array-index-key
        ,
        onMouseOver: () => setHoverTab(true),
        onMouseOut: () => setHoverTab(false),
        children: [/*#__PURE__*/_jsxs(TabTitle, {
          children: [tab.title, (tab === null || tab === void 0 ? void 0 : tab.badge) && !(tab !== null && tab !== void 0 && tab.renderBadge) && /*#__PURE__*/_jsx(BadgeWrapper, {
            children: tab === null || tab === void 0 ? void 0 : tab.badge
          }), (tab === null || tab === void 0 ? void 0 : tab.renderBadge) && /*#__PURE__*/_jsx(BadgeWrapper, {
            children: tab === null || tab === void 0 ? void 0 : tab.renderBadge({
              hoverTab
            })
          })]
        }), /*#__PURE__*/_jsx(Divider, {
          visible: tabIndex === activeTabIndex
        })]
      }, tabIndex)), /*#__PURE__*/_jsx(NextTabsCounter, {
        visible: Boolean(tabsPlacementCount.next),
        onClick: () => scrollOnClick('forward'),
        children: /*#__PURE__*/_jsxs(CounterWrapper, {
          children: [tabsPlacementCount.next, /*#__PURE__*/_jsx(ArrowTabs, {})]
        })
      })]
    }), tabs[activeTabIndex].content && /*#__PURE__*/_jsx(Content, {
      style: contentStyles,
      children: tabs[activeTabIndex].content
    })]
  });
};